import { render, staticRenderFns } from "./flowPic.vue?vue&type=template&id=18fc8ffe&scoped=true&"
import script from "./flowPic.vue?vue&type=script&lang=js&"
export * from "./flowPic.vue?vue&type=script&lang=js&"
import style0 from "./flowPic.vue?vue&type=style&index=0&id=18fc8ffe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc8ffe",
  null
  
)

export default component.exports